import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './shared/layout/layout.component';
import { LoginComponent } from './login/login.component';
import { BrowserModule } from '@angular/platform-browser';
import { ForgotPasswordComponent } from './userSettings/forgot-password/forgot-password.component';
import { AppResolver } from './app-resolver.service';
import { ChangePasswordComponent } from './userSettings/change-password/change-password.component';
import { PortalLandingComponent } from './portal-landing/portal-landing.component';
import { AuthGuard } from './core/auth.guard';
import { Roles, Panel } from './enums';
import { RecoveryPasswordComponent } from './userSettings/recovery-password/recovery-password.component';

const routes: Routes =[
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
    data: { title: 'Login' }
  }, {
    path: '',
    component: LayoutComponent,
    children: [{
      path: '',
      loadChildren: () => import('src/app/shared/layout/layout.module').then(m => m.LayoutModule)             
    }],
    resolve: {
      cred: AppResolver
    }
  },
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  { path: 'forgot-password', component: ForgotPasswordComponent, data: { title: 'Forgot Password' } },
  { path: 'passwordrecovery', component: RecoveryPasswordComponent, data: { title: 'Password Recovery' } },
  { path: 'portalLanding', component: PortalLandingComponent, canActivate: [AuthGuard], data: {title: 'Portal Landing', roles: [Roles[Roles.Admin].toString()] } },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
  providers:[AppResolver]
})
export class AppRoutingModule { }
